import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../../constants/colors';
import { shadows } from '../../constants/shadows';
import { FontSize, FontWeight, Transitions } from '../../theme';
import { getTypographyFontSize } from 'theme/selectors';
import { mediaSmDown } from '../../theme/helpers/css';

const dayStyles = css`
  width: 32px;
  display: flex;
  height: 32px;
  align-items: center;
  justify-content: center;
`;

const StyledPopper = styled.div`
  .react-datepicker-popper {
    z-index: 3;
  }

  .react-datepicker {
    width: 304px;
    background: ${colors.white};
    box-shadow: ${shadows.dropShadow};
    border-radius: 12px;
    padding: 16px;
    border: 1px solid ${colors.silver};
  }

  .react-datepicker__month {
    display: grid;
    grid-template-rows: repeat(5, 1fr);
  }

  .react-datepicker__week,
  .react-datepicker__day-names {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-column-gap: 8px;
  }

  .react-datepicker__day--today {
    font-weight: ${FontWeight.bold};
  }

  .react-datepicker__day-name {
    ${dayStyles};
    color: ${colors.greyish};
    ${getTypographyFontSize(FontSize.xs)}
    ${mediaSmDown`
      ${getTypographyFontSize(FontSize.xs)}
    `}
  }

  .react-datepicker__day {
    ${dayStyles};
    border-radius: 12px;
    transition: ${Transitions.color}, ${Transitions.bg};
    &:hover {
      background-color: ${colors.lightPaleGrey};
      cursor: pointer;
    }
    &:focus {
      outline: none;
    }
  }

  .react-datepicker__day--selected {
    background: ${colors.darkBlueGreen};
    color: ${colors.white};
    &:hover {
      background-color: ${colors.darkBlueGreenTwo};
    }
  }
  .react-datepicker__day--disabled {
    pointer-events: none;
    color: ${colors.greyish};
  }

  .react-datepicker__day--outside-month {
    color: ${colors.greyish};
  }
`;

const Popper: FC = ({ children, ...props }) => {
  if (!children) {
    return null;
  }

  return <StyledPopper {...props}>{children}</StyledPopper>;
};

export default Popper;
